import { RouteRecordRaw } from "vue-router";

const routes: Readonly<RouteRecordRaw[]> = [
  {
    path: "/auth/login",
    name: "PAuthLogin",
    meta: {
      auth: false,
      layout: "auth",
    },
    component: () => import("@/modules/Auth/pages/PLogin.vue"),
  },
  {
    path: "/auth/register",
    name: "PAuthRegister",
    meta: {
      auth: false,
      layout: "auth",
    },
    component: () => import("@/modules/Auth/pages/PRegister.vue"),
  },
  {
    path: "/auth/blocked",
    name: "PAuthBlocked",
    meta: {
      auth: false,
      layout: "auth",
    },
    component: () => import("@/modules/Auth/pages/PBlocked.vue"),
  },
  {
    path: "/auth/forgot-password",
    name: "PAuthForgetPassword",
    meta: {
      auth: false,
      layout: "auth",
    },
    component: () => import("@/modules/Auth/pages/PForgetRecovery.vue"),
  },
  {
    path: "/auth/reset-password",
    name: "PResetPassword",
    meta: {
      auth: false,
      layout: "auth",
    },
    component: () => import("@/modules/Auth/pages/PResetPassword.vue"),
  },
];

export default routes;
